import { render, staticRenderFns } from "./AccessServices.vue?vue&type=template&id=b917a54a&lang=pug&"
import script from "./AccessServices.vue?vue&type=script&lang=js&"
export * from "./AccessServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports